import { SelectListItemRenderer } from '@acies/core';
import { ComponentCO2Link } from '@acies/domain';
import { CheckBox, Label } from '@acies/ui';

export default class ComponentCO2LinkItemRenderer extends SelectListItemRenderer<ComponentCO2Link> {
	#checkBox!: CheckBox<ComponentCO2Link>;
	#nameLabel!: Label;
	#descriptionLabel!: Label;
	public constructor() {
		super();
		this.width = 'fill';
		this.height = 32;
		this.alignment = 'left';
		this.paddingHorizontal = 16;
		this.gapHorizontal = 16;
		this.enabled = false;
		this.selectedObservableValueChanged = this.selectedObservableValueChanged.bind(this);
	}

	override dispose(): void {
		super.dispose();
		if (this.item && this.item.selected) {
			this.item.selected.unsubscribe(this.selectedObservableValueChanged);
		}
	}

	protected override initialize(): void {
		super.initialize();
		this.#createChildren();
	}

	protected override itemChanged(): void {
		super.itemChanged();
		this.checkBox.item = this.item;
		if (this.item) {
			this.nameLabel.text = this.item.name;
			this.descriptionLabel.text = this.item.description;
			this.item.selected.subscribe(this.selectedObservableValueChanged);
		} else {
			this.nameLabel.text = '';
			this.descriptionLabel.text = '';
			this.checkBox.selected = false;
		}
	}

	private get checkBox(): CheckBox<ComponentCO2Link> {
		if (!this.#checkBox) {
			this.#checkBox = new CheckBox();
		}
		return this.#checkBox;
	}

	private get nameLabel(): Label {
		if (!this.#nameLabel) {
			this.#nameLabel = new Label();
			this.#nameLabel.width = 'fill';
		}
		return this.#nameLabel;
	}

	private get descriptionLabel(): Label {
		if (!this.#descriptionLabel) {
			this.#descriptionLabel = new Label();
			this.#descriptionLabel.width = 128;
		}
		return this.#descriptionLabel;
	}

	private selectedObservableValueChanged(value: boolean): void {
		this.checkBox.selected = value;
	}

	#createChildren(): void {
		this.addComponents([this.checkBox, this.nameLabel, this.descriptionLabel]);
	}
}
customElements.define('ac-component-co2-link-item-renderer', ComponentCO2LinkItemRenderer);
